import React from 'react';
import { Box, Tooltip, Typography } from '@material-ui/core';
import { InsertDriveFile } from '@material-ui/icons';

import { FilePreviewProps, FileByTypePreviewProps } from './types';
import { getFileInfo, getFileTypeByExtension, isBase64File, isMinIOFile, noop } from './helpers';

const FILE_TYPES_MAP = new Map([
  ['document', ApplicationPreview],
  ['video', ApplicationPreview],
  ['image', ImagePreview],
]);

const FilePreview = ({ file, sx }: FilePreviewProps) => {
  const fileInfo = getFileInfo(file);

  if (!file || !fileInfo) return null;

  const File = FILE_TYPES_MAP.get(getFileTypeByExtension(fileInfo.extension)) || noop;

  return <File file={file} sx={sx} {...fileInfo} />;
};

function ImagePreview({ file, extension, name, size, sx }: FileByTypePreviewProps) {
  const preview =
    (file instanceof File && URL.createObjectURL(file)) ||
    (isBase64File(file) && file) ||
    (isMinIOFile(file) && file.downloadUrl) ||
    '';

  return (
    <Box sx={sx}>
      <img
        src={preview}
        alt={`${size} | ${name}.${extension}`}
        onLoad={() => (file instanceof File ? URL.revokeObjectURL(preview) : null)}
        style={{ maxWidth: '100%', width: '100%', objectFit: 'cover', height: '100%' }}
      />
    </Box>
  );
}

function ApplicationPreview({ file, extension, name, size, sx }: FileByTypePreviewProps) {
  return (
    <Tooltip title={`Скачать ${name}.${extension}`}>
      <Box
        aria-label={`${name}.${extension}`}
        sx={{
          ...sx,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}
      >
        <InsertDriveFile style={{ fontSize: 64 }} color="primary" />

        <Typography variant="body1" style={{ position: 'absolute', top: '50%', color: 'white' }}>
          <b>.{extension}</b>
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default FilePreview;
